declare global {
    interface Window {
        _mfq: any
        dataLayer: any
    }
}

export const trackSubmitApplication = () => {
    console.log('Track submit application')
    // Add submit application tracking
}
